import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
// this points to desktop
import { msGeocode } from '@desktopComponents/map/utils/msGeocoding';
import { Icon } from '@desktopComponents/icon';
import { app } from '../stores/app';
import { MapButton } from './mapButton';

import './mapToolbar.css';

export function viewJurisdiction(map) {
  // when ctrl, we save current boundaries
  let boundaries = app?.dbConfig?.MAP_BASE_BOUNDARIES;
  if (!boundaries || !map?.fitBounds) return;

  let bnds = JSON.parse(boundaries);
  map.fitBounds(L.latLngBounds(bnds));
}

export const MapViewJurisdictionControl = observer((props) => {
  let { map } = props;
  return (
    <MapButton
      value="viewarea"
      title="View Jurisdiction"
      text={<Icon icon="fullscreen" size="lg" />}
      onClick={() => viewJurisdiction(map)}
    />
  );
})

export const MapGeocodeControl = observer((props) => {
  let { map, onGeocode } = props;
  let [text, setText] = useState('');
  let [state, setState] = useState({ visible: false });
  let ref = useRef(null);

  function showToggle(e) {
    setState({ ...state, visible: !state.visible });
    setTimeout(() => {
      ref.current.focus();
    }, 100);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      geocode();
    }
  }

  function geocode() {
    msGeocode(text, (err, results, response) => {
      if (onGeocode) {
        return onGeocode(err, results);
      }
      if (err) {
        console.log(err);
        return;
      }
      if (results.results.length > 0) {
        let res = results.results[0];
        map.fitBounds(res.bounds);
        let marker = L.marker(res.latlng, { pane: 'msMarkersPane' });

        // popup text
        let text = document.createElement('div');
        text.innerHTML = res.text + ' ';
        let closeLink = document.createElement('a');
        closeLink.className = 'linkImportant';
        closeLink.innerHTML = 'close';
        text.appendChild(closeLink);
        text.onclick = e => {
          map.removeLayer(marker);
        };

        // add that text popup.
        map.addLayer(marker);
        marker.bindPopup(text).openPopup();
      }
    });
  }

  return (
    <MapButton
      value="search"
      title="Search Address"
      text={<Icon icon="search" size="lg" />}
      onClick={showToggle}
    >
      <input
        className={classNames('geocode-search-input', {
          'geocode-search-input--visible': state.visible
        })}
        ref={ref}
        value={text}
        onChange={e => setText(e.target.value)}
        onClick={e => e.stopPropagation()}
        onKeyDown={handleKeyDown}
      />
    </MapButton>
  );
})

const MapToolbar = observer(function MapToolbar({ store, onGeocode }) {
  if (store == null) return null;

  return (
    <div className="leaflet-bar">
      <div className="btn-group" style={{ display: 'block' }}>
        <MapViewJurisdictionControl map={store.map} />
      </div>
    </div>
  );
});

MapToolbar.propTypes = {
  store: PropTypes.object.isRequired,
  onGeocode: PropTypes.func,
};

export default MapToolbar;
